import { Action } from 'redux';
import { SpaceInfo } from '../../state/SpaceInfo';
import { EnterSpace } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface EnterSpaceAction extends Action, SpaceInfo {}

export function enterSpace(spaceInfo: SpaceInfo): EnterSpaceAction {
  return {
    type: EnterSpace,
    ...spaceInfo
  };
}

export const isEnterSpaceAction = isActionFactory<EnterSpaceAction>(EnterSpace);
